module.exports = __webpack_public_path__ + "static/media/addCard.26a886c2.svg";